import React, { forwardRef } from 'react';
import { AlertTitle, Alert as MuiAlert, AlertProps } from '@mui/material';
import { IAlert } from './interfaces';

type AlertComponentProps = IAlert &
  Omit<AlertProps, keyof IAlert | 'children'>;

export const Alert = forwardRef<HTMLDivElement, AlertComponentProps>(
  function Alert(
    { title, content, severity = 'info', sx, variant, onClose, ...other },
    ref
  ): JSX.Element {
    return (
      <MuiAlert
        ref={ref}
        severity={severity}
        sx={sx}
        variant={variant}
        onClose={onClose}
        {...other}
      >
        {title && (
          <AlertTitle
            fontWeight="bold"
            fontSize="1em"
            sx={{
              fontWeight: 'bold',
            }}
          >
            {title}
          </AlertTitle>
        )}
        {content}
      </MuiAlert>
    );
  }
);
